<template>
  <div class="comReport">
    <div class="modules">
      <div class="topSteps_wrap">
        <div class="topSteps" >
        <div class="steps" id="steps1">
          <img class="steps_t1" :src="require(`../../assets/images/icon_check_${common.theme}.png`)" alt=""/>
          <div class="steps_t2 steps_t2_a">待处理</div>
          <div class="steps_t3">{{details.createdAt?details.createdAt:''}}</div>
          <div :class="['steps_line',details.complainStatus<2||listLength==0?'':'steps_line_active']"></div>
        </div>
        <div class="steps" id="steps2">
          <div class="steps_t1_b" v-if="details.complainStatus<2||listLength==0"></div>
          <img class="steps_t1" v-else :src="require(`../../assets/images/icon_check_${common.theme}.png`)" alt=""/>
          <div :class="['steps_t2',details.complainStatus>1&&listLength!=0?'steps_t2_a':'']">处理中</div>
          <div class="steps_t3" v-if="listLength>0">{{listLength!=0?details.complainFollowingBeanList[0].createdAt:''}}</div>
          <div :class="['steps_line',details.complainStatus<3?'':'steps_line_active']"></div>
        </div>
        <div class="steps" id="steps3">
          <div class="steps_t1_b" v-if="details.complainStatus<4"></div>
          <img class="steps_t1" v-else  :src="require(`../../assets/images/icon_check_${common.theme}.png`)" alt=""/>
          <div :class="['steps_t2',details.complainStatus>3?'steps_t2_a':'']">已关闭</div>
          <div class="steps_t3" v-if="details.complainStatus==4">{{details|closeTimeFilter()}}</div>
          <div class="steps_t3" v-else></div>
        </div>
        </div>
      </div>
    </div>

    <div class="modules">
      <div class="title">
        <span class="modules_tag"></span>
        <span class="modules_title">投诉详情</span>
      </div>
      <div class="item">
        <span class="item_t1">投诉时间</span><span class="item_t2">{{details.createdAt}}</span>
      </div>
      <div class="item">
        <span class="item_t1">联系人</span><span class="item_t2">{{details.complainant}}</span>
      </div>
      <div class="item">
        <span class="item_t1">联系电话</span><span class="item_t2">{{details.phoneNo}}</span>
      </div>
      <div class="item" v-if="details.lesseeName">
        <span class="item_t1">我的企业</span><span class="item_t2">{{details.lesseeName}}</span>
      </div>
      <div class="item">
        <span class="item_t1">投诉类型</span><span class="item_t2">{{details.complainType|complainTypeFilters(complainType)}}</span>
      </div>
      <div class="item">
        <span class="item_t1">投诉内容</span><span class="item_t2">{{details.complainContent}}</span>
      </div>
      <div class="item">
        <span class="item_t1"></span>
        <div class="item_t2">
          <div class="showPic" v-for="(item,index) in fileList" :key="item.path" @click="viewImage(item.path,index)">
            <img class="file" :src="item.path" alt="">
            <!-- <video v-else class="file" :src="item.path" autoplay poster="posterimage.jpg">

            </video> -->
          </div>
        </div>
      </div>
    </div>

    <div class="modules" v-for="(item,index) in details.complainFollowingBeanList" :key="index">
      <div class="title">
        <span class="modules_tag"></span>
        <span class="modules_title">处理记录</span>
      </div>
      <div class="item">
        <span class="item_t1">处理内容</span><span class="item_t2">{{item.resolvent}}</span>
      </div>
      <div class="item">
        <span class="item_t1">跟进人</span><span class="item_t2">{{item.createdByName?item.createdByName:''}}</span>
      </div>
      <div class="item">
        <span class="item_t1">处理时间</span><span class="item_t2">{{item.createdAt}}</span>
      </div>
    </div>

    <div class="modules" v-if="details.complainStatus==4">
      <div class="title">
        <span class="modules_tag"></span>
        <span class="modules_title">结果反馈</span>
      </div>
      <div class="item">
        <span class="item_t1">处理内容</span><span class="item_t2">{{details.solutionResult}}</span>
      </div>
      <div class="item">
        <span class="item_t1">关闭人</span><span class="item_t2">{{details.modifyByName}}</span>
        <!-- <span class="item_t1">关闭人</span><span class="item_t2">{{details.complainFollowingBeanList.length!=0?details.complainFollowingBeanList[0].createdByName:''}}</span> -->
      </div>
      <div class="item">
        <span class="item_t1">关闭时间</span><span class="item_t2">{{details.modifyAt}}</span>
        <!-- <span class="item_t1">关闭时间</span><span class="item_t2">{{details.complainFollowingBeanList.length!=0?details.complainFollowingBeanList[0].createdAt:''}}</span> -->
      </div>
    </div>


    <div class="bottomBtn_wrap_h">
    </div>
    <div class="bottomBtn_wrap" v-if="details.complainStatus==4&&logLength==0&&hasEvaluateButton">
      <div class="bottomBtn" @click="evaluate()">去评价</div>
    </div>
    <div class="bottomBtn_wrap" v-if="details.complainStatus==4&&logLength!=0">
      <div class="bottomBtn" @click="viewEvaluate()">查看评价</div>
    </div>
       <!-- 查看大图 -->
  <fade-animation>
    <common-gallary :imgs="arrImgs" :curIndex="curIndex" v-show="showGallary" @close="showGallary=false"></common-gallary>
  </fade-animation>
  </div>
</template>

<script>
// import BScroll from "better-scroll";
import { callSpaceUp,spaceUpPcHttp,checkEvaluateButton} from '../../utils/api'
import util from "../../utils/util";
import storage from "../../utils/storage";
import { mapState } from 'vuex';
import CommonGallary from "../../components/Gallary";
import FadeAnimation from "../../components/FadeAnimation";
export default {
  name:"repairComplaintDetails",
  data () {
    return {
      arrImgs:[],
      curIndex:0,
      showGallary:false,
      searchFileUrl:spaceUpPcHttp+'/syscfg/attachmentTerminal/queryAttachmentListByOneData',
      headers: {
        "Access-channel": "saas_rst"
      },
      visitorOutput:{},
      QRCode:'',
      mode:'',
      totalAmount:0,
      /*
      * 详情数据
      */
      details:{},
      /*
      * 处理列表大小
      */
      listLength:0,
      /*
      * 附件
      */
      fileList:'',
      hex_md5_return:"",
      timemap:"",
      scroll:'',
      logLength:0,
      complainType:[],

      hasEvaluateButton:false
    };
  },
  computed: {
    ...mapState({
      userId: state => state.common.userId,
      common: state => state.common,
    })
  },
  components:{
    CommonGallary,
    FadeAnimation
  },
  created () {
    // 公钥+私钥+时间戳+平台
    let gong = 'vanke2019spaceup009'
    let si = '009vanke2019spaceup001'
    let platfrom = 'SaasMobile'
    this.timemap = new Date().getTime()
    let str = gong+si+this.timemap+platfrom
    this.hex_md5_return = this.$md5(str)
    this.complainType = this.$route.query.cityId?this.common.ziDianData.complain_type:[]
    this.fetchData();
    this.searchImages();
    this.fetchCheckEvaluateButton();
  },
  activated() {
    this.fetchData();
    this.searchImages();
  },
  mounted(){
  },
  filters:{
    closeTimeFilter(details){
      return details.complainFollowingBeanList.length!=0?details.complainFollowingBeanList[0].createdAt:''
    },
    closePeople(details){
      return details.complainFollowingBeanList.length!=0?details.complainFollowingBeanList[0].createdByName:''
    },
    listFilter(details){
      return details.complainFollowingBeanList&&details.complainFollowingBeanList.length>1&&details.complainStatus==4?details.complainFollowingBeanList[details.complainFollowingBeanList.length-1].createdAt:''
    },
    dateFilter(value,util){
      return  value?util.formatTime(value,11):''
    },
    complainTypeFilters(value,arr){
      for (let i = 0; i < arr.length; i++) {
        if(arr[i].code == value){
          return arr[i].text
        }

      }
    }
  },
  methods: {
    fetchCheckEvaluateButton(){
       checkEvaluateButton({
         "templateType": 4
       }).then(res => {
         if (res.res.code === 10000) {
           this.hasEvaluateButton = res.body.hasEvaluateButton
         }
       })
    },
    viewImage(url,index) {
      this.fileList.forEach((item,i)=>{
        this.$set(this.arrImgs,i,item.path)
      })
      this.curIndex = index
      this.showGallary = true
    },
    getComplainType() {
      let self = this;
      let parmes = {
        companyId:self.$route.query.cityId?self.$route.query.cityId:self.common.userInfo.cityId,
        url: "/property/rstRepair/initDictWhenLoginName"
      }
      callSpaceUp(parmes).then(res => {
        console.log("字典项")
        console.log(res)
        if (res.res.code == 10000) {
          this.complainType = res.body.data.complain_type
        }
      });
    },
    viewEvaluate(){
      let item = this.details
      this.$router.push(`/evaluate/viewEvaluate?id=${item.id}`);
    },
    evaluate () {
      let item = this.details
      this.$router.push(`/evaluate/evaluate?id=${item.id}&referenceName=投诉建议&templateType=4&referenceNo=${item.complainCode}&myCompanyId=${item.companyId}&target=${item.modifyByName}&targetPhone=${item.modifyByPhoneNo}`)
    },
    viewThis(item){
      let type = item.postfix
      let path = item.path
      let self = this;
      storage.set("viewImgList",JSON.stringify(self.fileList))
      if(type.indexOf('png')!=-1||type.indexOf('jpeg')!=-1||type.indexOf('jpg')!=-1){
        this.$router.push(`/viewImage?url=${path}`);
      }else{
        this.$router.push(`/viewVideo?url=${path}`);
      }
    },
    searchImages(){
      let self = this;
      let parmes = {
        'moduleCode': 'TM',
        'target': self.$route.query.id,
        'platform': 'SaasMobile',
        'timestamp': self.timemap,
        'sign':self.hex_md5_return,
        'companyId':self.$route.query.cityId?self.$route.query.cityId:self.common.userInfo.cityId
      }
      let cityId = self.$route.query.cityId?self.$route.query.cityId:self.common.userInfo.cityId
      fetch(self.searchFileUrl+"?moduleCode=TM&target="+self.$route.query.id+"&platform=SaasMobile"+"&timestamp="+self.timemap+"&sign="+self.hex_md5_return+"&companyId="+cityId, {
        method: 'get',
        headers:self.headers
      }).then(response => response.json()).then(res => {
        console.log(res)
        this.fileList = res.data.filter((item,index)=>{return index < 9})
      })
    },
    confirm() {
      let self = this
      util.showModal('','确定要关闭工单吗？',true,'确定',
       function(){
          self.close()
      })
    },
    close() {
      let self = this;
      let closeTime = util.formatTime(new Date,11);
      let marketId = self.$route.query.marketId?self.$route.query.marketId:this.common.marketInfo.id
      let postInfo = {
         id:this.details.id,//	true	普通参数	int		单条投诉id
         subProjectId:Number(marketId),//	true	普通参数	int		子项目id
         'url':'/property/rstRepair/loadCpsComplainHeaderById'
      }
      callSpaceUp(postInfo).then(res => {
        console.log(res);
        util.hideLoading();
        if(res.res.code==10000){
          util.showToast("关闭成功");
          this.fetchData()
        }
      });
    },
    callPhone(phone) {
      if (phone !== "") {
        window.location.href = "tel:" + phone;
      } else {
        util.showToast("暂无维修工电话");
      }
    },
    getQRCode: function () {
      let content = {
        qrcode: this.visitorOutput.qrcode
      }
      transformToBase64(content).then(res => {
        if (res.res.code === 10000) {
          console.log("res二维码")
          console.log(res)
          this.QRCode = res.body.encodeBase64
        }
      });
    },
    cancel() {
      let self = this;
      util.showModal('温馨提示','确定取消吗？',true,'确定',
         function(){
            self.cancelVisitor();
        }, function(){
            console.log(0)
        })
    },
    //取消预约
   cancelVisitor(){
     let self = this;
      cancelVisitorById({
        "visitorId": this.$route.query.id
      }).then(res => {
        console.log(res)
        if (res.res.code === 10000) {
          self.fetchData();
        }
      })
    },
    fetchData(){
      let self = this;
      let marketId = self.$route.query.marketId?self.$route.query.marketId:this.common.marketInfo.id
      callSpaceUp({
        id:this.$route.query.id,//	true	普通参数	int		单条投诉id
        subProjectId:Number(marketId),//	true	普通参数	int		子项目id
        url: "/property/rstRepair/loadCpsComplainHeaderById"
      }).then(res => {
        console.log('投诉详情')
         console.log(res)
         this.getComplainType();
         if(res.res.code == 10000){
           this.details = res.body.data
           this.logLength = this.details.logEvaluateContentVoList?this.details.logEvaluateContentVoList.length:0
           this.listLength = this.details.complainFollowingBeanList?this.details.complainFollowingBeanList.length:0
         }

      })
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../assets/css/common.less";
.comReport {
  background:rgba(238,238,238,1);
  min-height: 100vh;
  width: 100%;
  overflow-x: hidden;
  .modules{
    margin-bottom: 14px;
    padding: 28px;
    box-sizing: border-box;
    background: #ffffff;
    .topSteps_wrap{
      width: 100%;
      overflow-x: hidden;
    }
    .m0_wrap,.statusBox{
      display: flex;
      flex-direction: column;
      align-items: center;
      .status_line{
        margin-bottom: 10px;
      }
      .success{
        width: 32px;
        height: 32px;
        margin: 10px;
      }
      .line_icon{
        width: 16px;
        height: 16px;
        margin: 18px;
        border-radius: 50%;
        background:rgba(218,218,218,1);
      }
      .line{
        display: inline-block;
        width: 186px;
        height: 2px;
        border-top:2px solid #1740da;
        margin: 25px 0
      }
      .text{
        width: 136px;
        line-height: 28px;
        color:rgba(153,153,153,1);
      }
      .text2{
        margin-bottom: 10px;
      }
      .line2{
        width: 124px;
      }
      .line3{
        width: 84px;
      }
      .statusIcon{
        width: 100px;
        height: 100px;
        margin-bottom: 20px;
      }
      .statusText{
        text-align: center;
        color:rgba(102,102,102,1);
        font-size: 28px;
      }
    }
    .m1_wrap{
      display: flex;
      flex-direction: column;
      align-items: center;
      .m1_text1{
        height:28px;
        font-size:24px;


        color:rgba(153,153,153,1);
        line-height:28px;
        margin-bottom: 28px;
      }
      .m1_icon{
        width: 320px;
        height: 320px;
        margin-bottom: 28px;
        background: #f3f4f6;
      }
      .m1_text2{
        font-size:28px;


        color:rgba(51,51,51,1);
      }
    }

    .title{
      display: flex;
      margin-bottom: 28px;
      .modules_tag{
        display: inline-block;
        width: 6px;
        height: 24px;
        margin: 10px 12px 12px 0;
        background:rgba(23,64,218,1);
      }
      .modules_title{
        height:44px;
        font-size:32px;

        font-weight:500;
        color:rgba(51,51,51,1);
        line-height:44px;
      }
    }
    .item{
      display: flex;
      margin-bottom: 20px;
      .item_t1,.item_t2{
        min-width:160px;
        font-size:26px;


        color:rgba(153,153,153,1);
        line-height:36px;
        margin-right: 36px;
      }
      .item_t2{
        color:rgba(51,51,51,1);
        margin-right: 0px;
        display: flex;
        flex-wrap: wrap;
        word-break:break-all;
      }
      .showPic{
        width: 120px;
        height: 120px;
        border-radius: 8px;
        margin-right: 14px;
        margin-bottom: 14px;
        .file{
          width: 120px;
          height: 120px;
          border-radius: 8px;
        }
      }
    }

  }
  .bottomBtn_wrap_h{
    height:108px;
  }
  .bottomBtn_wrap{
    width:100%;
    height:108px;
    background:rgba(255,255,255,1);
    position: fixed;
    left: 0;
    bottom: 0;
    .bottomBtn{
      // width:694px;
      margin:0 28px;
      height:76px;
      background:rgba(23,64,218,1);
      border-radius:4px;
      text-align: center;
      line-height: 76px;
      font-size:32px;


      color:rgba(255,255,255,1);
      margin: 16px 28px;
    }
  }

.people{
  margin-bottom: 14px;
  .people_title{
    padding: 0 40px;
    box-sizing: border-box;
    font-size:24px;
    font-family:PingFangSC-Regular,PingFangSC;

    color:rgba(153,153,153,1);
    line-height:56px;
    text-align: left;
  }
  .people_item{
    height: 156px;
    display: flex;
    padding: 28px;
    box-sizing: border-box;
    align-items: center;
    background: #fff;
    position: relative;
    .people_phone{
      position: absolute;
      width: 32px;
      height: 32px;
      right: 40px;
      top: 62px;
    }
    .people_icon{
      width:100px;
      height:100px;
      border-radius: 50%;
      margin-right: 28px;
      background: #f3f4f6;
    }
    .people_con_t1{
      height:28px;
      font-size:28px;
      font-family:PingFangSC-Medium,PingFangSC;
      font-weight:500;
      color:rgba(51,51,51,1);
      line-height: 28px;
      margin-bottom: 26px;
    }
    .people_con_t2{
      height:28px;
      font-size:28px;
      font-family:PingFangSC-Regular,PingFangSC;

      color:rgba(153,153,153,1);
      line-height:28px;
    }
  }
}
 //进度
 .topSteps{
  height: 178px;
  background: #fff;
  display: flex;
  justify-content: center;
  padding:14px 0 0;
  box-sizing: border-box;
}
.steps{
  // width: 218px;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative
}
.steps_line{
 position: absolute;
 height: 1px;
 width: 154px;
 border-bottom: 1px solid #F4F4F4;
 top: 23px;
 right:-74px;
}
.steps_line_active{
 border-bottom: 1px solid #1740DA;
}
.steps_t1{
  width: 46px;
  height: 46px;
  border-radius: 50%;
  margin: 0 86px 10px;
}
.steps_t1_b{
  width: 16px;
  height: 16px;
  margin: 15px 101px 25px;
  border-radius: 50%;
  background: #C8C8C8;
}
.steps_t2{
  height:36px;
  font-size:26px;


  color:#999999;
  line-height:36px;
  margin-bottom: 6px;
  text-align: center
}
.steps_t2_a{
  color: #333333;
}
.steps_t3{
  width:136px;
  font-size:20px;


  color:rgba(102,102,102,1);
  line-height:28px;
  text-align: center
}
.material{
  padding: 0 28px;
  box-sizing: border-box;
  background: #fff;
  margin-bottom: 14px;
  overflow: hidden;
  .material_title{
    height: 100px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .material_title_1,.material_title_2,.material_title_2_c{
      font-size:32px;
      font-family:PingFangSC-Medium,PingFangSC;
      font-weight:500;
      color:rgba(51,51,51,1);
    }
    .material_title_2{
      font-family:PingFangSC-Regular,PingFangSC;

    }
    .material_title_2_c{
      color: #FC3F56;
      font-family:PingFangSC-Regular,PingFangSC;

    }
  }
  .material_list{
   .material_item{
     margin-bottom: 40px;
     display: flex;
     overflow: hidden;
     .material_item_l{
       width: 120px;
       height: 120px;
       margin-right: 20px;
     }
     .material_item_r1{
        height:28px;
        font-size:24px;
        font-family:PingFangSC-Regular,PingFangSC;

        color:rgba(51,51,51,1);
        line-height:28px;
        margin-bottom: 20px;
     }
     .material_item_r2{
        height:28px;
        font-size:24px;
        font-family:PingFangSC-Regular,PingFangSC;

        color:rgba(51,51,51,1);
        line-height:28px;
        margin-bottom: 16px;
     }
     .material_item_r3{
        height:28px;
        font-size:24px;
        font-family:PingFangSC-Regular,PingFangSC;

        color:rgba(153,153,153,1);
        line-height:28px;
     }
   }
  }
}
}
</style>
